import BaseService from '@/services/BaseService'
import Service from '@/models/service'
import {Group} from '@/models/group'

export class ServiceService extends BaseService<Service> {
  constructor() {
    super('services/')
  }

  public async availableGroupNames(): Promise<Group[]> {
    const result = await this.instance.get(this.resourcePath + 'group-names/')
    return result.data
  }

  public async availableServices(
    roles: string[],
    targetName: string,
  ): Promise<Service[]> {
    const result = await this.instance.get(this.resourcePath + 'can-assign/', {
      params: {
        roles,
        target: targetName,
      },
    })
    return result.data
  }

  public async forPartner(): Promise<Service[]> {
    const result = await this.instance.get(this.resourcePath + '/for-partner/')
    return result.data
  }
}

export default new ServiceService()
